// extracted by mini-css-extract-plugin
export default {"plain-text":"LmdCRDoUuI","plainText":"LmdCRDoUuI"};